import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl, ValidationErrors } from '@angular/forms';
import { ListDocumentProfileSurvey } from '../../../class/list-document-profile-survey';
import { ListDocumentProfileSurveyService } from '../../../service/list-document-profile-survey/list-document-profile-survey.service';
import { TranslateService } from '@ngx-translate/core';
import { Message, SelectItem, MultiSelectModule, AutoCompleteModule, CalendarModule } from 'primeng/primeng';
import { MapsAPILoader } from '@agm/core';
import { Marker } from '../../../../../interfaces/marker';
import { NotificationsService } from '../../../../../theme/services/notifications/notifications.service';
import { HasPermissionService } from '../../../service/has-permission/has-permission.service';
import { UploadFilesService } from '../../../service/upload-files/upload-files.service';
import { config } from '../../../../../../environments/config';
import { calendarES } from '../../../../../theme/functions/calendarES';

@Component({
  selector: 'app-new-list-document-profile-survey',
  templateUrl: './new-list-document-profile-survey.component.html',
  styleUrls: ['./new-list-document-profile-survey.component.scss']
})
export class NewListDocumentProfileSurveyComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() edit: ListDocumentProfileSurvey;
    @Output() reload: EventEmitter<number> = new EventEmitter<number>();

    messages: Message[] = [];

    public promiseForm: Promise<any>;
    public form: FormGroup;

    public company_id: AbstractControl;
    public name: AbstractControl;
    public attachment: AbstractControl;
    public type: AbstractControl;
    public termination: AbstractControl;
    public mutual_termination: AbstractControl;
    public renunciation: AbstractControl;
    public responsability: AbstractControl;

    public responsabilityOptions: any[];
    public optionsType: any[];

    public es: any;
    public save_exit: boolean;

    public uploadedAttachment: any[] = [];
    public prewiewAttachment: any;
    public promiseAttachment: Promise<any>;

    public apiUrl = config.API_ROOT;


    constructor(
        fb: FormBuilder,
        public listDocumentProfileSurveyService: ListDocumentProfileSurveyService,
        public translate: TranslateService,
        public uploadFilesService: UploadFilesService,
        private notificationsService: NotificationsService) {

        this.save_exit = false;

        this.optionsType = [
            {label: 'Contratación', value: 'Contratación'},
            {label: 'Relación laboral', value: 'Relación laboral'},
            {label: 'Retiro', value: 'Retiro'},
            {label: 'Jurídica', value: 'Jurídica'}
        ];

        this.responsabilityOptions = [
            {id: 1, label: 'candidate', value: 'Candidato'},
            {id: 2, label: 'psychologist', value: 'Sicólogo'},
        ];

        this.es = calendarES();

        this.form = fb.group({
            'company_id': [''],
            'name': ['', Validators.compose([ Validators.required, Validators.minLength(2) ])],
            'attachment': [''],
            'responsability' : ['', Validators.compose([ Validators.required, Validators.minLength(2) ])],
            'type': ['', Validators.compose([ Validators.required ])],
            'termination': [''],
            'mutual_termination': [''],
            'renunciation': [''],
        });
        
        this.company_id = this.form.controls['company_id'];
        this.name = this.form.controls['name'];
        this.attachment = this.form.controls['attachment'];
        this.responsability = this.form.controls['responsability'];
        this.type = this.form.controls['type'];
        this.termination = this.form.controls['termination'];
        this.mutual_termination = this.form.controls['mutual_termination'];
        this.renunciation = this.form.controls['renunciation'];
    }

    ngOnInit() {
        if (this.edit) {
            this.company_id.setValue(this.edit.company_id);
            this.name.setValue(this.edit.name);
            this.responsability.setValue(this.edit.responsability);
            this.type.setValue(this.edit.type);
            this.termination.setValue(this.edit.termination);
            this.mutual_termination.setValue(this.edit.mutual_termination);
            this.renunciation.setValue(this.edit.renunciation);

            if (this.edit.attachment) {
                this.uploadedAttachment = [];
                this.uploadedAttachment.push({'name': 'Archivo Adjunto  '});
            }
        } else {
            // this.activated.setValue(true);
            this.termination.setValue(false);
            this.mutual_termination.setValue(false);
            this.renunciation.setValue(false);
        }
    }

    public cancelListDocumentProfileSurvey () {
        console.log('reset');
        this.form.reset();
        this.close.emit(true);
    }

    public saveandexit (values){
        this.save_exit = true;
        this.newListDocumentProfileSurvey(values);
    }

    public newListDocumentProfileSurvey(values) {
        let company;
        if (values.company_id) {
            if (values.company_id.id) {
                company = values.company_id.id;
            }
        }

        const param = {
            company_id: company,
            name: values.name,
            responsability: values.responsability,
            type: values.type,
            termination: values.termination,
            mutual_termination: values.mutual_termination,
            renunciation: values.renunciation,
        };

        if (values && this.form.valid) {
            const promise = (this.edit) ?
            this.listDocumentProfileSurveyService.updateListDocumentProfileSurvey(this.edit.id, param)
            :
            this.listDocumentProfileSurveyService.newListDocumentProfileSurvey(param);

            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.notificationsService.growlNotify('success', res);
                        // this.msg.emit( { severity: 'success', summary: res  } );
                        if (this.save_exit) {
                            this.close.emit(true);
                            this.form.reset();
                            this.save_exit = false;
                        } else {
                            this.reload.emit(response.json().id);
                            // this.getListDocumentProfileSurveyId(response.json().id)
                        }
                        
                    });
                },
                error => {
                    let msg = '';
                    this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                        this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                            JSON.parse(error._body).errors.forEach(element => {
                                if (element.source) {
                                    if (element.source.pointer) {
                                        this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                            msg = msg + res3 + ', ';
                                        });
                                    }
                                }
                            });
                            this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                            // this.msg.emit( { severity: 'error', summary: 'Error' } );
                        });
                    });
                }
            );
        }
    }

    public getListDocumentProfileSurveyId(id) {
        this.listDocumentProfileSurveyService.infoListDocumentProfileSurvey(id).toPromise().then(
            response => {
                this.edit = response.json().data[0];
            },
            error => {
                let msg = '';
                this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                    this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                        JSON.parse(error._body).errors.forEach(element => {
                            if (element.source) {
                                if (element.source.pointer) {
                                    this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                        msg = msg + res3 + ', ';
                                    });
                                }
                            }
                        });
                        this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                        // this.msg.emit( { severity: 'error', summary: 'Error' } );
                    });
                });
            }
        );
    }

    public onUpload(event: any) {
        this.uploadedAttachment = [];
        for (const file of event.srcElement.files) {
            this.uploadedAttachment.push(file);
        }
        if (event.target.files && event.target.files[0]) {
            const reader = new FileReader();
            reader.onload = () => {
              this.prewiewAttachment = reader.result;
            };
            reader.readAsDataURL(event.target.files[0]);
        }
    }

    public updateAttachment(event: any) {
        this.translate.get('uploading').subscribe((res: string) => {
            this.notificationsService.growlNotify('info', res + '...');
        });

        this.translate.get('uploading').subscribe((res: string) => {
            this.notificationsService.growlNotify('info', res + '...');
        });

        this.uploadedAttachment = [];
        for (const file of event.files) {
            this.uploadedAttachment.push(file);
        }

        this.promiseAttachment = this.uploadFilesService.updateAttachmentProfileSurvey(this.uploadedAttachment, this.edit.id).toPromise().then(
            response => {
                this.translate.get('saved').subscribe((res: string) => {
                    this.notificationsService.growlNotify('success', res);
                });
                // this.getProfile();
                // this.avatar = this.prewiewAttachment;
            },
            error => {
                let msg = '';
                this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                    this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                        JSON.parse(error._body).errors.forEach(element => {
                            if (element.source) {
                                if (element.source.pointer) {
                                    this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                        msg = msg + res3 + ', ';
                                    });
                                }
                            }
                        });
                        this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                        // this.msg.emit( { severity: 'error', summary: 'Error' } );
                    });
                });
            }
        );
    }

    public gotoAttachment() {
        window.open(this.apiUrl + '/list-document-profile-surveis/' + this.edit.id + '/attachment' + '?token=' + localStorage.getItem('token'), '_blank');
    }

    getFormValidationErrors(form) {
        let value = '';
        Object.keys(form.controls).forEach(key => {
            const controlErrors: ValidationErrors = form.get(key).errors;
            if (controlErrors != null) {
                Object.keys(controlErrors).forEach(keyError => {
                    value = 'Key control: ' + key + ', keyError: ' + keyError + ', err value: ' + controlErrors[keyError];
                });
            }
        });
        return (value);
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/list-document-profile-surveis/new-list-document-profile-survey/new-list-document-profile-survey.component.ts